import { useContractsQuery } from '@/src/api/use-contracts-query';
import { useProductsQuery } from '@/src/api/use-products-query';
import { useCustomerClassificationV2 } from '@/src/hooks/HomeServices/useCustomerClassificationV2';
import {
  getHasNoChargeAnytime,
  getHasNoGreenerElectricity,
  getHasNoHomeServices,
  getHasStartedSupply,
  getIsEligiblePaymentMethod,
} from './newWebEligibility';

export type NewWebEligibility = {
  isEligible: boolean;
  isReady: boolean;
  isEligibleAtTimeout: boolean;
};

// An unresolved or failed call keeps `isReady` false rather than mis-bucketing the customer.
// `isEligibleAtTimeout` is the verdict once the caller stops waiting: classification is a
// flaky serial chain, so only that check is forgiven while unresolved — never the core ones.
export const useNewWebEligibility = (
  accountId: string | null | undefined,
): NewWebEligibility => {
  const contracts = useContractsQuery(accountId);
  const products = useProductsQuery(accountId);
  const classification = useCustomerClassificationV2();

  const coreChecks = [
    getHasStartedSupply(contracts.data?.data),
    getIsEligiblePaymentMethod(contracts.data?.data),
    getHasNoGreenerElectricity(products.data),
    getHasNoChargeAnytime(products.data),
  ];
  const hasNoHomeServices = getHasNoHomeServices(classification);

  const coreReady = coreChecks.every(check => check !== undefined);
  const coreEligible = coreChecks.every(Boolean);
  const isReady = coreReady && hasNoHomeServices !== undefined;

  return {
    isReady,
    isEligible: isReady && coreEligible && hasNoHomeServices === true,
    isEligibleAtTimeout: coreEligible && hasNoHomeServices !== false,
  };
};
